import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";

import { provider } from "../../../../../../../../components/api/endpoints/provider";
import { SelectOptionsDataProcessor } from "../../../../../../../../components/global/SelectOptionsDataProcessor";
import DataContext from "../../../../../../../../context/DataContext";

export const useFieldOptionsMedicalDocumentsStatus = () => {
  const { accessToken } = useContext(DataContext);

  const { isPending, error, data } = useQuery({
    queryKey: ["FieldOptions-Medical-Documents-Status"],
    queryFn: async () => {
      const response = provider.getMedicalDocumentStatusFieldOptions(accessToken);
      return await response;
    },
    select: (data) => SelectOptionsDataProcessor(data.results, "No Selection"),
  });

  return {
    isPending,
    error,
    data,
  };
};
